<template>
  <div>
    <v-row class="mx-auto pb-3" justify="center">
      <v-col cols="12" class="pa-0">
        <h2 class="mt-5 text-center black--text">
          {{ $t("regis_transaction.title") }}
        </h2>
      </v-col>
      <v-col cols="12" lg="8" class="mb-0 pa-0">
        <v-simple-table dense class="mt-2">
          <template v-slot:default>
            <thead>
              <tr class="grey white--text">
                <th class="text-center">
                  {{ $t("regis_transaction.order") }}
                </th>
                <th class="text-center">
                  {{ $t("regis_transaction.type") }}
                </th>
                <th class="text-center">
                  {{ $t("regis_transaction.subject_id") }}
                </th>
                <th class="text-center">
                  {{ $t("regis_transaction.subject_name") }}
                </th>
                <th class="text-center">
                  {{ $t("regis_transaction.section") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("regis_transaction.timestamp") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(item_transactions,
                index_transactions) in computed_regis_transactions"
              >
                <tr
                  :class="
                    index_transactions % 2 === 0
                      ? 'grey lighten-2'
                      : 'grey lighten-5'
                  "
                  v-for="(item, index) in item_transactions"
                  :key="item.TEACH_TABLE_ID"
                >
                  <td v-if="index === 0" :rowspan="item_transactions.length">
                    {{ item.order }}
                  </td>
                  <td
                    class="text-center"
                    v-if="index === 0"
                    :rowspan="item_transactions.length"
                  >
                    <span v-if="item.tran_type === 'R'">{{
                      $t("regis_transaction.tran_type_r")
                    }}</span>
                    <span v-if="item.tran_type === 'A'">{{
                      $t("regis_transaction.tran_type_a")
                    }}</span>
                    <span v-if="item.tran_type === 'C'">{{
                      $t("regis_transaction.tran_type_c")
                    }}</span>
                    <span v-if="item.tran_type === 'D'">{{
                      $t("regis_transaction.tran_type_d")
                    }}</span>
                  </td>
                  <td>{{ item.subject_id }}</td>
                  <td>
                    <a class="subject-link" @click="openSubjectDialog(item.subject_id)">
                      {{ item.subject_ename }}
                    </a>
                    <span
                      v-if="item.c2subject_id != ''"
                      class="font-weight-bold orange--text"
                    >
                      ({{ $t("regis_transaction.changed_to") }}
                      {{ item.c2subject_id }})</span
                    >
                  </td>
                  <td class="text-center">{{ item.section }}</td>

                  <td
                    class="text-center last-cell"
                    v-if="index === 0"
                    :rowspan="item_transactions.length"
                  >
                    <span v-if="item.date_time">
                      {{
                        db_datetime_to_dayjs(item.date_time)
                          .locale(lang)
                          .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm:ss`)
                      }}
                    </span>
                  </td>
                </tr>
              </template>
              <tr
                v-if="
                  !computed_regis_transactions ||
                    computed_regis_transactions.length === 0
                "
                class="grey lighten-4"
              >
                <td class="last-cell text-center" colspan="10">
                  {{ $t("queue_table_panel.no_item") }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <subject-dialog ref="subject_dialog" :level-id="level_id" />
  </div>
</template>

<script>
import { db_datetime_to_dayjs } from "@/helper/dateTime";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

export default {
  name: "RegisTransaction",
  components: {
    SubjectDialog,
  },
  props: {
    regis_transactions: {
      type: Array,
    },
    level_id: {
      type: [String, Number],
      default: 1,
    },
  },
  methods: {
    db_datetime_to_dayjs,
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
  },
  computed: {
    computed_regis_transactions() {
      let temp = {};

      this.regis_transactions.map((item) => {
        if (temp[item.order]) temp[item.order].push(item);
        else temp[item.order] = [item];
      });

      return Object.values(temp);
    },
    lang() {
      if (this.$root.$i18n.locale) return this.$root.$i18n.locale;
      return "th";
    },
  },
};
</script>

<style scoped>
.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
